(function () {


  function settleGuideAnchor() {
    var id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (error) { return; }
    var target = id && document.getElementById(id);
    if (!target || !target.closest('.oc-guide-page__content, .blog-post-section--buyer-guide .blog-post-content')) return;
    var active = true;
    var events = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    var images = Array.from(document.querySelectorAll('.oc-guide-page__content img, .blog-post-section--buyer-guide .blog-post-content img')).filter(function (img) {
      return Boolean(img.compareDocumentPosition(target) & Node.DOCUMENT_POSITION_FOLLOWING);
    });
    function align() {
      if (active && window.location.hash.slice(1) === encodeURIComponent(id)) target.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
    function stop() {
      active = false;
      events.forEach(function (name) { window.removeEventListener(name, stop); });
      window.removeEventListener('hashchange', stop);
      window.removeEventListener('load', align);
      images.forEach(function (img) { img.removeEventListener('load', align); img.removeEventListener('error', align); });
    }
    events.forEach(function (name) { window.addEventListener(name, stop, { once: true, passive: true }); });
    window.addEventListener('hashchange', stop, { once: true });
    images.forEach(function (img) { if (!img.complete) { img.addEventListener('load', align); img.addEventListener('error', align); } });
    window.addEventListener('load', align, { once: true });
    if (document.fonts) document.fonts.ready.then(align);
    requestAnimationFrame(align);
    window.setTimeout(stop, 10000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', settleGuideAnchor, { once: true });
  else settleGuideAnchor();
  function emphasizeGuideTitle() {
    var phrases = {
      'skate-ramp-dimensions': 'Space and Fit',
      'skate-ramp-surface': 'Skate Ramp Surface',
      'skate-ramp-kit-vs-diy': 'Skate Ramp Kit',
      'skate-ramp-cost': 'Skate Ramp Budget',
      'types-of-skateboard-ramps': 'Skateboard Ramps',
      'skate-ramp-shape': 'Skate Ramp Shape',
      'skate-ramp-site-preparation': 'Prepare Your Site',
      'skate-ramp-shipping-delivery': 'Skate Ramp Shipping and Delivery',
      'skate-ramp-kit-assembly': 'Skate Ramp Kit Assembly',
      'skate-ramp-care': 'Skate Ramp Care',
      'first-timer-where-do-i-start': 'Where Do I Start?'
    };
    var heading = document.querySelector('#MainContent h1');
    var phrase = phrases[window.location.pathname.split('/').filter(Boolean).pop()];
    if (!phrase && heading) phrase = Object.values(phrases).find(function (candidate) { return heading.textContent.indexOf(candidate) !== -1; });
    if (!phrase || !heading || heading.querySelector('.oc-guide-accent')) return;
    var text = heading.textContent;
    var start = text.indexOf(phrase);
    if (start < 0) return;
    var accent = document.createElement('span');
    accent.className = 'oc-guide-accent';
    accent.textContent = phrase;
    heading.replaceChildren(document.createTextNode(text.slice(0, start)), accent, document.createTextNode(text.slice(start + phrase.length)));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', emphasizeGuideTitle);
  else emphasizeGuideTitle();
  window.addEventListener('load', emphasizeGuideTitle);
  document.addEventListener('shopify:section:load', emphasizeGuideTitle);
  if (window.ocGuideChatListener) return;
  window.ocGuideChatListener = true;
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href="/pages/contact-us"]');
    if (!link || !link.closest('#MainContent') || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var chat = window.tidioChatApi;
    if (!chat || typeof chat.open !== 'function' || typeof chat.show !== 'function') return;
    try {
      chat.show();
      chat.open();
      event.preventDefault();
    } catch (error) {

    }
  });
})();
